import s from "./AdminLoginPage.module.scss";
import React, { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

export default function AdminLoginPage() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    login: '',
    password: '',
  })
  const [hasSubmitted, setHasSubmitted] = useState(false)
  const {responseData,  isLoading, error, submitRequest} = useAuth()


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value } = e.target
    setFormData(prev => ({...prev,[name]: value}))
  } // для моментального обновления данных формы при изменении

  const handleSubmit = useCallback(async(event: React.FormEvent) => {
    event.preventDefault();
    const success = await submitRequest(formData.login, formData.password)
    setHasSubmitted(true)
    if(success){
      setFormData({
        login: '',
        password: '',
      })
    }

  }, [submitRequest, formData])

  useEffect(()=>{
    if(hasSubmitted && responseData && !error){
      navigate('/admin/login/panel')
      setHasSubmitted(false)
    }
  },[hasSubmitted, responseData, error, navigate])

  return (
    <>
      <main className={s.main}>
        <form className={s.authForm} onSubmit={handleSubmit}>
          <div className={s.container_AF}>
            <h2>Вход в админку</h2>

            <div className={s.container_enter}>
            <input type="text"
            placeholder="Логин"
            name="login"
            onChange={handleChange}
            value={formData.login}
            className={s.inputForm} />

            <input type="password"
            placeholder="Пароль"
            name="password"
            onChange={handleChange}
            value={formData.password}
            className={s.inputForm} />
          </div>
          <button type="submit" className={s.button} >Войти</button>

          </div>
            
          
        </form>
      </main>
    </>
  );
}